export const sv = {
  returnLineItems: {
    refund: "Återbetalning(ar)",
    exchange: "Byte(n)",
    discount: "Rabatt(er)",
  },
  returnStoreAddress: {
    mapButton: "Visa på karta",
  },
  downloadLabel: {
    label: "Ladda ner min etikett",
    bonDeRetour: "Ladda ner min retursedel",
  },
  returnRequestDate: {
    label: "Din returbegäran gjordes den {{date}} kl. {{time}}",
  },
  actions: {
    continue: "Fortsätt",
  },
  "order-identification": {
    title: "Spåra din beställning",
    description: "Ange dina beställningsuppgifter för att spåra ditt paket",
    fields: {
      "zip-code": {
        title: "Postnummer",
        description: "Ange ditt leveranspostnummer",
        required: "Postnummer är obligatoriskt",
      },
      email: {
        title: "E-postadress",
        description: "Ange den e-postadress du använde för din beställning",
        required: "E-postadress krävs",
      },
      both: {
        title: "Postnummer eller e-post",
        description: "Ange ditt leveranspostnummer eller den e-post som användes för din beställning",
        required: "Postnummer eller e-post krävs",
      },
      "tracking-number": {
        title: "Beställningsnummer",
        description: "Ange ditt beställningsnummer",
        required: "Beställningsnummer är obligatoriskt",
      },
    },
    errors: {
      "unknown-order": {
        title: "Okänt beställningsnummer",
        description:
          "Beställningsnumret hittades inte, vänligen kontrollera det",
      },
      "search-error": {
        title: "Sökfel",
        description: "Vi kunde inte hitta beställningen. Försök igen senare.",
      },
    },
  },
  delivery: "Leverans",
  "parcel-history": "Pakethistorik",
  "order-details": {
    title: "Orderdetaljer",
    "tracking-number": "Spårningsnummer",
    "order-number": "Ordernummer",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Beräknat leveransdatum",
      deliveredOn: "Levererad den",
      from: "från",
      to: "till",
    },
  },
  deliveryAddress: {
    title: "Leveransadress:",
    titlePickup: "Adress till upphämtningsställe:",
    orderDetails: {
      title: "Beställningsdetaljer:",
      trackingNumber: "Spårningsnummer:",
      orderNumber: "Beställningsnummer:",
      orderDate: "Beställningsdatum:",
    },
  },
  pickupPoint: {
    title: "Upphämtningsställe",
    openingHours: "Öppettider:",
    closed: "Stängt",
    directions: "Vägbeskrivning",
    days: {
      monday: "Måndag:",
      tuesday: "Tisdag:",
      wednesday: "Onsdag:",
      thursday: "Torsdag:",
      friday: "Fredag:",
      saturday: "Lördag:",
      sunday: "Söndag:",
    },
  },
  wallet: {
    warningNotEnabled: "Du måste aktivera Wallet i dina butiksinställningar",
  },
  crossSell: {
    youMightAlsoLike: "Du kanske också gillar",
  },
  "rate-order": {
    "order-recap": {
      title: "Din beställning",
      "tracking-label": "Spårningsnummer:",
      "order-label": "Ordernummer:",
    },
    form: {
      title: "Betygsätt din leverans",
      "rating-label": "Betygsätt din leveransupplevelse",
      "comment-label": "Kommentar (valfritt)",
      "comment-placeholder": "Dela din upplevelse med oss…",
      "submit-cta": "Skicka in mitt omdöme",
      "update-cta": "Uppdatera mitt omdöme",
      "rating-required": "Välj ett betyg.",
    },
    "thank-you": {
      title: "Tack för din feedback!",
      description:
        "Ditt omdöme har sparats. Det hjälper oss att förbättra leveransupplevelsen.",
    },
    errors: {
      "invalid-token": {
        title: "Ogiltig eller utgången länk",
        description:
          "Den här länken är inte längre giltig. Öppna den igen från ditt senaste spårningsmejl.",
      },
      submit: {
        title: "Något gick fel",
        description:
          "Vi kunde inte spara ditt omdöme. Försök igen senare.",
      },
    },
  },
  shippingInstructions: {
    colissimo: "Du kan nu skriva ut din returetikett och lämna in ditt paket vid närmaste Colissimo-ombud.",
    chronoShop2Shop: "Du kan nu skriva ut din returetikett och lämna in ditt paket vid närmaste Chronopost-ombud.",
    ups: "Du kan nu skriva ut din returetikett och lämna in ditt paket vid närmaste UPS-ombud.",
    customerCarrier: "Du kan nu skicka ditt returpaket med den transportör du själv väljer.",
    merchantCarrier: "Vi skickar en returetikett till dig via e-post inom 1 till 3 arbetsdagar.",
    returnToStore: "Du kan nu lämna in ditt paket i närmaste butik.",
    malca: "Du kan nu skriva ut din returetikett och lämna in ditt paket vid närmaste Malca-ombud.",
    tnt: "Du kan nu skriva ut din returetikett och lämna in ditt paket vid närmaste TNT-ombud.",
    bonDeRetour: "Din retursedel är klar. Du kan nu skriva ut den och använda den för din retur.",
    unknownCarrier:
      "Du kan nu skriva ut din returetikett och skicka ditt paket med transportören som anges på etiketten.",
  },
  shippingInstructionsTitle: {
    shippingLabel: "Din fraktetikett är klar",
    bonDeRetour: "Din returblankett är klar",
  },
} as const;
